import axios from './index';

export const loginRequest = (reqObj) => axios.post('/v1/admins/login/admin', reqObj);
